import { render } from "./ContactsOfficeCompany.vue?vue&type=template&id=34bbf162&scoped=true"
import script from "./ContactsOfficeCompany.vue?vue&type=script&lang=js"
export * from "./ContactsOfficeCompany.vue?vue&type=script&lang=js"

import "./ContactsOfficeCompany.vue?vue&type=style&index=0&id=34bbf162&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bbf162"]])

export default __exports__